import { compose, withState, withProps, withHandlers } from 'coact/recompose'

import View from './StocksTable.jsx'

const StocksTable = compose(
  withState('imageModal', 'setImageModal', null),
  withHandlers({
    showModal:
      ({ setImageModal }) =>
      imageName =>
        setImageModal(imageName),
    hideModal:
      ({ setImageModal }) =>
      () =>
        setImageModal(null),
  }),
  withProps({
    productsData: [],
  }),
)(View)

StocksTable.displayName = 'StocksTable'

export default StocksTable
